import { FormattedMessage } from 'react-intl';
import React from 'react';
import { useSelector } from 'react-redux';
import { AccountList } from '../../../banking/components/AccountList/AccountList';
import { messages as bundledFlowMessages } from '../../../reports/components/BundledFlow/molecules/messages';
import { useSelectedProvider } from '../../../components/App/ProviderContainer/useSelectedProvider';
import { AppState } from '../../../stores/redux-store';
import { LoadingOverlay } from '../../../core/screens/LoadingOverlay/LoadingOverlay';
import { BackButton } from '../../../components/organisms/Header/HeaderMolecule';
import {
  useAwaitingAccountsSelectionMachineView,
  UseAwaitingAccountsSelectionMachineViewProps,
} from './useAwaitingAccountsSelectionMachineView';

export type AwaitingAccountsSelectionMachineViewProps =
  UseAwaitingAccountsSelectionMachineViewProps & BackButton;

export const AwaitingAccountsSelectionMachineView = ({
  credentials,
  onBack,
  onDone,
}: AwaitingAccountsSelectionMachineViewProps) => {
  const [current, send] = useAwaitingAccountsSelectionMachineView({ credentials, onDone });
  const { selectedProvider } = useSelectedProvider();

  const oauthDescription = useSelector((state: AppState) => state.oauth.description!);

  if (current.matches('GET_ACCOUNTS_DONE')) {
    return (
      <AccountList
        title={<FormattedMessage {...bundledFlowMessages.selectYourAccount} />}
        subTitle={
          <FormattedMessage
            {...bundledFlowMessages.selectYourAccountSubHeader}
            values={{ clientName: oauthDescription.clientName }}
          />
        }
        allowSelectMultipleAccounts={false}
        accounts={current.context.accounts}
        providerDisplayName={selectedProvider.displayName}
        providerLogo={selectedProvider.images.icon}
        onBack={onBack}
        onSubmit={(accountIds) => {
          send('EVENT_ACCOUNTS_SELECTED', {
            data: accountIds,
          });
        }}
      />
    );
  }

  return <LoadingOverlay />;
};
